angular
  .module('GlobalControllers')

  .controller('NotContactCtrl', [
    '$scope',
    '$http',
    'API_URL',
    'navbar',
    function($scope, $http, API_URL, navbar) {
      navbar.goBackAction('Accueil', '#!/', 'navbar.home');

      $scope.contact = {
        email: '',
        content: '',
        subject: '',
        phone: ''
      };

      $scope.submit = function() {
        $http
          .post(API_URL + '/contact', $scope.contact)
          .success(function() {
            $scope.sent = true;
          })
          .error(function(data) {
            console.log(data);
          });
      };
    }
  ]);
